// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9ef58107","821":"42e005bf"}[chunkId] + ".chunk.js";
};